import dayjs, { Dayjs } from "dayjs";

const date = new Date();

const year = date.getFullYear();
const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
const day = String(date.getDate()).padStart(2, "0");
const hours = String(date.getHours()).padStart(2, "0");
const minutes = String(date.getMinutes()).padStart(2, "0");
const seconds = String(date.getSeconds()).padStart(2, "0");
const milliseconds = String(date.getMilliseconds()).padStart(2, "0");

//used in fund submit
export const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;



export const formatDateTime = (isoString) => {
  const date = new Date(isoString);

  // Get individual date parts
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  // Get individual time parts
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format and pad with 0
  hours = String(hours % 12 || 12).padStart(2, "0");

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};


//used in loan submit
export const convertDate = (inputDate) => {
  const [year, month, day] = inputDate.split("-").map(Number);
  // Construct the date in UTC (not local time)
  const date = new Date(Date.UTC(year, month - 1, day));
  // Return ISO string without 'Z' if needed
  return date.toISOString().replace("Z", "");
};


export function formatNormalDate(timestamp) {
  const date = new Date(timestamp);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export function formatDayJs_MM_DD_YYYY(timestamp) {
  const date = new Date(timestamp);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return dayjs(`${month}-${day}-${year}`, "MM-DD-YYYY");
}
export function formatDate(dateString) {
  const date = new Date(dateString);

  // Get the month, day, and year
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  // Return in MM/DD/YYYY format
  return `${month}/${day}/${year}`;
}

export function formatDateToMMDDYYYY(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();

  return `${mm}/${dd}/${yyyy}`;
}
